// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_0JF","cls2":"CoauthorConfirmationCard-cls2_df7 CoauthorConfirmationCard-cls1_0JF"};